export enum templateType {
  LIST = 1,
  CREATE = 2,
  EDIT = 3,
}
